import { ClickAwayListener } from '@mui/material';

const PeekClickAwayListener = ClickAwayListener;

export { PeekClickAwayListener, PeekClickAwayListener as default };
